export default __webpack_public_path__ + "static/media/checkin.b58335a1.png";